// extracted by mini-css-extract-plugin
export default {"alert":"RecsForm_alert__3HHoa","commanderPad":"RecsForm_commanderPad__9iJd5","icon":"RecsForm_icon__MrjGX","submit":"RecsForm_submit__dlDKw"};